(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["image-text-slider"] && !window.DesignMode) return;
  try {
    
  function showAlert() {
    console.log('listen to shopify theme editor re-render');
  }

  document.addEventListener("shopify:section:load", showAlert);

  } catch(e) { console.error(e); }
})();
})();
